import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

initializeFaro({
  url: process.env.FARO_URL,
  app: {
    name: process.env.FARO_APP_NAME || 'sdv-faro',
    version: '1.0.0',
    environment: process.env.CHANNEL || 'development'
  },

  instrumentations: [
    // Mandatory, omits default instrumentations otherwise
    ...getWebInstrumentations(),

    // Tracing package to get end-to-end visibility for HTTP requests
    new TracingInstrumentation()
  ]
})
